// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3434":"076ee602e15225be","3644":"b9ad285b52703fb2"}[chunkId] + ".js";
};